import { FetchOptions } from '@/types/fetch-options'
import { getUrlWithParams, getRequestInit } from '../utils/fetch'

const ROOT_URL = '/api'

const get = async <T>({ url, init, params }: FetchOptions) => {
  const endpoint = getUrlWithParams(url, params)
  const response = await fetch(`${ROOT_URL}${endpoint}`, {
    cache: 'no-store',
    method: 'GET',
    ...getRequestInit(init),
  })
  return response.json() as Promise<T>
}

const post = async <T>({ url, init, body }: FetchOptions) => {
  const response = await fetch(`${ROOT_URL}${url}`, {
    method: 'POST',
    body: JSON.stringify(body),
    ...getRequestInit(init),
  })

  return (await response.json()) as Promise<T>
}

const patch = async <T>({ url, init, body }: FetchOptions) => {
  const response = await fetch(`${ROOT_URL}${url}`, {
    method: 'PATCH',
    body: JSON.stringify(body),
    ...getRequestInit(init),
  })
  return (await response.json()) as Promise<T>
}

const remove = async <T>({ url, init, params }: FetchOptions) => {
  const endpoint = getUrlWithParams(url, params)
  const response = await fetch(`${ROOT_URL}${endpoint}`, {
    method: 'DELETE',
    ...getRequestInit(init),
  })
  return (await response.json()) as Promise<T>
}

const nextApi = {
  get,
  post,
  patch,
  delete: remove,
}

export default nextApi
